module.exports = __webpack_public_path__ + "static/media/AvenirLTStd-Black.e2e3c9dd.woff";